import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import { PageTitle } from '../PageTitle';
import { ScrollModule } from "../ScrollModule"
import ScrollArea from "react-scrollbar";
import withSizes from 'react-sizes'
import i18next from "i18next";
import { EntityDetailModal } from '../Entity';
import { AlertListFilterArea, alertListFilterExtractFromState, alertListFilterExtractFromParams, alertListFilterToOptions } from "./monitor_alerts_list_filters";
import MonitorAlertListTable from "./monitor_alerts_list_table";

const AlertList = ({ location, history, isMobile, deviceGroupingId, grouping, onSuccess, onError }) => {
  const parsedOptions = QueryString.parse(location.search) ?? {};
  const currentHistoryCount = location.state?.currentHistoryCount ?? 0;
  const baseURL = location.pathname.replace("/events", "");

  const [filter, setFilter] = useState(alertListFilterExtractFromParams(alertListFilterExtractFromState(location.state ?? {}), parsedOptions));
  const [tableOptions, setTableOptions] = useState(location.state?.tableOptions ?? []);
  const [entitySerialNumber, setEntitySerialNumber] = useState(null);

  useEffect(() => {
    if (filter) {
      const params = [...tableOptions]
                            .concat(alertListFilterToOptions(filter))
                            .map((option) => Object.keys(option).map((k, _) => `${k}=${option[k]}`))
                            .join('&');

      const currentSearch = location.search ?? '?';
        
      if (`?${params}` !== currentSearch) {
        if (currentHistoryCount > 100) {
          console.error('Exceeded the history count stack of 100.');
          return false;
        }

        history.push({ search: `?${params}`, state: { filter: filter, currentHistoryCount: currentHistoryCount + 1, grouping: grouping, tableOptions: tableOptions } });
      }
    }
  }, [location, filter, tableOptions]);

  return (
        <div>
          <div className="row"> 
            <PageTitle title={ i18next.t('pages.alerts.header') } /> 
          </div>

          <div className="op-content-box">
            <ScrollModule/>
            <ScrollArea speed={ 0.8 } className="scroll-container" contentClassName="scrollable-content" horizontal={ true } >
              <div className="monitoring-location-map">

                <AlertListFilterArea filter={filter} deviceGroupingId={deviceGroupingId} onFilterChange={setFilter} onError={onError} />

                <MonitorAlertListTable
                  onSuccess={onSuccess}
                  onError={onError}
                  alertDetailPath={(alertId) => ({
                    pathname: `${baseURL}/events/${alertId}`,
                    state: { backLinkSearch: location.search }
                  })}
                  viewTicketPath={(ticketId) => ({
                    pathname: `${baseURL}/monitoring/tickets/view/${ticketId}`,
                    state: { backLinkSearch: location.search }
                  })}
                  parsedOptions={parsedOptions}
                  deviceGroupingId={deviceGroupingId}
                  onShowEntityModal={setEntitySerialNumber}
                  onTableOptionsChanged={setTableOptions}
                />

                <EntityDetailModal
                  isMobile={isMobile}
                  entitySerialNumber={entitySerialNumber}
                  show={entitySerialNumber != null}
                  onHide={() => setEntitySerialNumber(null)}
                  onError={onError}
                />

              </div>
            </ScrollArea>
          </div>
        </div>
    );
}

export default connect(({currentGrouping}) => ({ currentGrouping: currentGrouping.currentGrouping }))(withSizes(({ width }) => ({ isMobile: width < 470 }))(AlertList));
